import { CompanyNanoID } from '../companies/companiesTypes';
import { ProjectNanoID } from '../projects/projectsTypes';
import { InvoiceNanoID } from '../invoices/invoicesTypes';

export class GroupedItemCache {
  static proformaProjectGroupedItemsCacheKey(
    companyNanoId: CompanyNanoID,
    projectNanoId: ProjectNanoID
  ) {
    return `grouped-items-company-${companyNanoId}-project-${projectNanoId}`;
  }

  static proformaCompanyGroupedItemsCacheKey(companyNanoId: CompanyNanoID) {
    return `grouped-items-company-${companyNanoId}`;
  }

  static invoiceGroupedItemsCacheKey(invoiceNanoId: InvoiceNanoID) {
    return `grouped-items-invoice-${invoiceNanoId}`;
  }

  static projectGroupedItemsCacheKey(projectNanoId: ProjectNanoID) {
    return `grouped-items-project-${projectNanoId}`;
  }

  static projectPaymentsGroupedItemsCacheKey(projectNanoId: ProjectNanoID) {
    return `payments-grouped-items-project-${projectNanoId}`;
  }

  static allProjectPaymentsGroupedItemsMetaCacheKey(
    projectNanoId: ProjectNanoID
  ) {
    return `payments-grouped-items-meta-project-${projectNanoId}`;
  }

  static filteredProjectPaymentsGroupedItemsMetaCacheKey(
    projectNanoId: ProjectNanoID
  ) {
    return `payments-grouped-items-meta-project-${projectNanoId}`;
  }

  static createInvoiceFromProformaGroupedItemsCacheKey(
    companyNanoId: CompanyNanoID
  ) {
    return `create-invoice-from-proforma-grouped-items-company-${companyNanoId}`;
  }
}
